import { httpClient } from "./httpClient";

type Category = {
    id: number;
    name: string;
    isActive: boolean;
    isManual: boolean;
    businessUnit: {
        id: number;
        name: string;
    }
};

type Data = {
  systemCategories: Category[];
};

export async function getCategories(): Promise<Category[]> {
    try {
        const { data } = await httpClient.get<Data>(
            `/api/v1/system-categories`
        );

        return data.systemCategories;
    } catch (error) {
        throw error;
    }
}